import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PlayerAvatar } from "./PlayerAvatar";
import { BadgeIcon, toneClasses } from "./badges";
import { Loader2, Trophy } from "lucide-react";

export function AchievementsView({ onSelectPlayer }) {
  const [badges, setBadges] = useState(null);

  useEffect(() => {
    api.get("/achievements").then((r) => setBadges(r.data.badges)).catch(() => setBadges([]));
  }, []);

  if (badges === null) {
    return (
      <div className="py-16 flex justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-emerald-400" />
      </div>
    );
  }

  return (
    <div className="space-y-5" data-testid="achievements-view">
      <div>
        <div className="text-xs font-semibold uppercase tracking-[0.2em] text-emerald-400">
          Riconoscimenti
        </div>
        <h2 className="font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl text-white">
          Albo d'Oro
        </h2>
      </div>

      {badges.length === 0 ? (
        <div className="ap-card p-10 text-center text-slate-500">
          <Trophy className="w-10 h-10 mx-auto mb-3 text-slate-600" />
          I riconoscimenti compariranno dopo le prime partite giocate.
        </div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {badges.map((b) => {
            const tone = toneClasses(b.tone);
            const isPair = !!b.pair;
            const data = isPair ? b.pair : b.winner;
            return (
              <button
                key={b.id}
                data-testid={`badge-card-${b.id}`}
                onClick={() => onSelectPlayer?.((isPair ? data.player_ids[0] : data.player_id))}
                className={`group ap-card text-left p-5 flex flex-col gap-4 hover:border-white/20 transition-colors`}
              >
                <div className="flex items-start justify-between gap-3">
                  <div className={`w-12 h-12 rounded-2xl border flex items-center justify-center shadow-lg ${tone.chip} ${tone.ring}`}>
                    <BadgeIcon icon={b.icon} className={`w-6 h-6 ${tone.text}`} />
                  </div>
                  <span className={`font-mono font-black text-xl ${tone.text}`}>
                    {data.value}
                    <span className="block text-[9px] uppercase tracking-wider text-slate-500 text-right font-sans">
                      {data.label}
                    </span>
                  </span>
                </div>

                <div>
                  <div className="font-display uppercase tracking-tight text-lg text-white">{b.title}</div>
                  <div className="text-xs text-slate-400 mt-0.5 leading-snug">{b.desc}</div>
                </div>

                <div className="flex items-center gap-2 pt-1 border-t border-white/5 mt-auto">
                  {isPair ? (
                    <>
                      <div className="flex -space-x-2">
                        {data.player_ids.map((pid, i) => (
                          <PlayerAvatar key={pid} id={pid} name={data.names[i]} size={30} />
                        ))}
                      </div>
                      <span className="text-sm font-semibold text-white truncate">
                        {data.names.join(" / ")}
                      </span>
                    </>
                  ) : (
                    <>
                      <PlayerAvatar id={data.player_id} name={data.name} size={30} />
                      <span className="text-sm font-semibold text-white truncate group-hover:text-emerald-400 transition-colors">
                        {data.name}
                      </span>
                    </>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
